var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportReply({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16357_69397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 30,
    fill: "url(#paint0_linear_16357_69397)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 28.5,
    stroke: "#76BCFF",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16357_69397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 36.668V33.8333C42.6667 33.6327 42.546 33.4513 42.3613 33.3727C42.1773 33.2947 41.962 33.334 41.8187 33.4747L36.152 38.9747C36.0547 39.0687 36 39.198 36 39.3333C36 39.4687 36.0547 39.598 36.152 39.692L41.8187 45.192C41.9633 45.332 42.178 45.3713 42.3613 45.294C42.546 45.2153 42.6667 45.034 42.6667 44.8333V42H43.612C46.7027 42 49.552 43.68 51.0473 46.3813L51.0613 46.4067C51.1507 46.5693 51.32 46.6667 51.5 46.6667C51.5413 46.6667 51.5827 46.662 51.624 46.6513C51.8453 46.5947 52 46.3953 52 46.1667C52 40.984 47.8287 36.7573 42.6667 36.668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16357_69397",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.596078 0 0 0 0 0.996078 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16357_69397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16357_69397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16357_69397",
    x1: 9.48589,
    y1: -51.1999,
    x2: 87.2326,
    y2: -47.1922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16357_69397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(36 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportReply);
export default __webpack_public_path__ + "static/media/support_reply.c5ff7b1e68e85ebbeb2dcb1a6cf0c3f8.svg";
export { ForwardRef as ReactComponent };